import React from "react";

// services
import LearningContentService from "services/LearningContentService";

import { toast } from "react-toastify";

// core components
import DataDisplay from "../../../components/DataDisplayView/DataDisplay";

import { injectIntl, defineMessages } from "react-intl";
import Translations from "../content.json";

const messages = defineMessages(Translations);

const INITIAL_STATE = {
  open: false,
  isLoading: false,
  action: "",
  grBookList: [],
  grBookId: "",
  grBookContentId: "",
  grBookText: "",
  grBookContents: [],
  grBookTags: [],
  alert: null,
  showSnackBar: false,
  snackBarColor: "",
  snackBarMessage: "",
  openassignClassDialog: false,
  btnDisabled: false
};

class GRTag extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      ...INITIAL_STATE,
      direction: localStorage.getItem("direction"),
      language: localStorage.getItem("language"),
      grTagList: [],
      grTagListWithoutFilter: [],
      page: 0,
      rowsPerPage: 10,
      rowsPerPageOptions: [10, 25, 50]
    };
  }

  componentDidMount() {
    this.getGRTagData();
  }

  getGRTagData = _ => {
    this.setState({ open: false, isLoading: true });
    LearningContentService.fetchAllGRTagData()
      .then(response => {
        if (response && parseInt(response._statusCode) === 200)
          response._entity &&
            this.setState({
              grTagList: response._entity,
              grTagListWithoutFilter: response._entity
            });
        else throw response;
      })
      .then(_ => this.setState({ isLoading: false }))
      .catch(error => {
        const {
          intl: { formatMessage }
        } = this.props;
        let errorMessage = "";
        if (error && error._message) errorMessage = error._message;
        else errorMessage = formatMessage(messages.teachers.errorMessageText);
        this.setState(
          {
            isLoading: false,
            fetchData: false
          },
          () => {
            toast.error(errorMessage);
          }
        );
      });
  };

  onSearch = e => {
    const { grTagListWithoutFilter } = this.state;
    const value = e.target.value.toLowerCase();
    const filteredData = grTagListWithoutFilter.filter(
      x => x._code && x._code.toLowerCase().indexOf(value) !== -1
    );
    this.setState({ grTagList: filteredData });
  };

  render() {
    const { isLoading, grTagList } = this.state;

    //Default List
    let tbContentList = [];
    if (typeof grTagList !== "undefined" && grTagList.length > 0) {
      tbContentList = grTagList.map(item => {
        const { _id, _code, _textAr } = item;
        return [
          _id,
          _code,
          _textAr
        ];
      });
    }

    return (
      <DataDisplay
        tableHead={[
          "GR Tag Id",
          "GR Tag Code",
          "GR Tag Name"
        ]}
        tableData={tbContentList}
        search={this.onSearch}
        isLoading={isLoading}
        cardIconTitle="Lessons"
        searchPlaceHolderText="Search GR Tag"
        uploadButtonText="Upload GR Tag Data"
        uploadPath="/gr-tag/bulk-upload"
        colspan={3}
        customClassesForCells={[2]}
        customHeadClassesForCells={[2]}
      />
    );
  }
}

export default injectIntl(GRTag);
